//教学课程
export const COURSE_LIST = 'course_list'
export const COURSE_INFO = 'course_info'
export const COURSE_CHAPTER = 'course_chapter'
export const COURSE_CHAPTER_RES = 'course_chapter_res'
export const SYSTEM_MAJOR = 'system_major'
export const COURSE_MENU_LIST = 'course_menu_list'

export const COURSE_MATERIAL_INFO = 'COURSE_MATERIAL_INFO'

export const SK_COURSE_LIST = 'sk_course_list'

export const COURSE_CLOSE = 'course_close'



// WEBPACK FOOTER //
// ./src/store/jxCourse/type.js